import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const websitesRequest = createAction(types.WEBSITES_REQUEST);
export const websitesSuccess = createAction(types.WEBSITES_SUCCESS);
export const websitesFailure = createAction(types.WEBSITES_FAILURE);

export const websitesLightRequest = createAction(types.WEBSITES_LIGHT_REQUEST);
export const websitesLightSuccess = createAction(types.WEBSITES_LIGHT_SUCCESS);
export const websitesLightFailure = createAction(types.WEBSITES_LIGHT_FAILURE);

export const websiteRequest = createAction(types.WEBSITE_REQUEST);
export const websiteSuccess = createAction(types.WEBSITE_SUCCESS);
export const websiteFailure = createAction(types.WEBSITE_FAILURE);

export const createWebsiteRequest = createAction(types.CREATE_WEBSITE_REQUEST);
export const createWebsiteSuccess = createAction(types.CREATE_WEBSITE_SUCCESS);
export const createWebsiteFailure = createAction(types.CREATE_WEBSITE_FAILURE);

export const updateWebsiteRequest = createAction(types.UPDATE_WEBSITE_REQUEST);
export const updateWebsiteSuccess = createAction(types.UPDATE_WEBSITE_SUCCESS);
export const updateWebsiteFailure = createAction(types.UPDATE_WEBSITE_FAILURE);

export const setWebsiteThemeRequest = createAction(
  types.SET_WEBSITE_THEME_REQUEST,
);
export const setWebsiteThemeSuccess = createAction(
  types.SET_WEBSITE_THEME_SUCCESS,
);
export const setWebsiteThemeFailure = createAction(
  types.SET_WEBSITE_THEME_FAILURE,
);

export const availableThemesRequest = createAction(
  types.AVAILABLE_THEMES_REQUEST,
);
export const availableThemesSuccess = createAction(
  types.AVAILABLE_THEMES_SUCCESS,
);
export const availableThemesFailure = createAction(
  types.AVAILABLE_THEMES_FAILURE,
);

export const availableFontsRequest = createAction(
  types.AVAILABLE_FONTS_REQUEST,
);
export const availableFontsSuccess = createAction(
  types.AVAILABLE_FONTS_SUCCESS,
);
export const availableFontsFailure = createAction(
  types.AVAILABLE_FONTS_FAILURE,
);

export const deleteWebsiteRequest = createAction(types.DELETE_WEBSITE_REQUEST);
export const deleteWebsiteSuccess = createAction(types.DELETE_WEBSITE_SUCCESS);
export const deleteWebsiteFailure = createAction(types.DELETE_WEBSITE_FAILURE);

export const updateWebsiteTmpRequest = createAction(
  types.WEBSITE_UPDATE_TMP_REQUEST,
);
export const updateWebsiteTmpSuccess = createAction(
  types.WEBSITE_UPDATE_TMP_SUCCESS,
);
export const updateWebsiteTmpFailure = createAction(
  types.WEBSITE_UPDATE_TMP_FAILURE,
);

export const resetWebsite = createAction(types.RESET_WEBSITE);

const websiteActions = {
  resetWebsite,
  websitesRequest,
  websitesSuccess,
  websitesFailure,
  websiteRequest,
  websiteSuccess,
  websiteFailure,
  websitesLightRequest,
  websitesLightSuccess,
  websitesLightFailure,
  createWebsiteRequest,
  createWebsiteSuccess,
  createWebsiteFailure,
  updateWebsiteRequest,
  updateWebsiteSuccess,
  updateWebsiteFailure,
  setWebsiteThemeRequest,
  setWebsiteThemeSuccess,
  setWebsiteThemeFailure,
  deleteWebsiteRequest,
  deleteWebsiteSuccess,
  deleteWebsiteFailure,
  updateWebsiteTmpRequest,
  updateWebsiteTmpSuccess,
  updateWebsiteTmpFailure,
  availableThemesRequest,
  availableThemesSuccess,
  availableThemesFailure,
  availableFontsRequest,
  availableFontsSuccess,
  availableFontsFailure,
};

export default websiteActions;
